import { createRouter, createWebHistory } from 'vue-router'

import PatientsList from '../js/components/patient/PatientsList.vue';
import History from '../js/components/patient/History.vue';
import EchoPage from '../js/components/echo/EchoPage.vue';
import AuditLogViewer from '../js/components/audit/AuditLogViewer.vue';
import ExportsHistory from '../js/components/exports/ExportHistory.vue';
import Account from '../js/components/auth/Account.vue';
import LoginView from '../js/views/LoginView.vue';
import AppShell from '../js/components/layout/AppShell.vue';
import { auth } from '../js/firebase/config.js';
import { onAuthStateChanged } from 'firebase/auth';

const getCurrentUser = () =>
    new Promise((resolve) => {
        const unsub = onAuthStateChanged(auth, (user) => {
            unsub()
            resolve(user)
        })
    })

const routes = [
    {
        path: '/login',
        name: 'login',
        component: LoginView,
        meta: { guestOnly: true },
    },
    {
        path: '/',
        component: AppShell,
        meta: { requiresAuth: true },
        children: [
            { path: '', redirect: { name: 'formular' } },
            { path: 'formular', name: 'formular', component: EchoPage },
            { path: 'pacienti', name: 'pacienti', component: PatientsList },
            { path: 'istoric', name: 'istoric', component: History },
            { path: 'audit', name: 'audit', component: AuditLogViewer },
            { path: 'exporturi', name: 'exporturi', component: ExportsHistory },
            { path: 'cont', name: 'cont', component: Account },
        ],
    },
    { path: '/:pathMatch(.*)*', redirect: { name: 'formular' } },
]

export const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach(async (to) => {
    const user = await getCurrentUser()

    if (to.meta.requiresAuth && !user) {
        return { name: 'login' }
    }

    if (to.meta.guestOnly && user) {
        return { name: 'formular' }
    }

    return true;
})

export default router;